import { __assign } from 'tslib';
import React__default from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

var CSS_MAIN_CLASS = "PictureViewer";
var CSS_ACTIONS_CLASS = "".concat(CSS_MAIN_CLASS, "-Actions");
var PictureViewer = function PictureViewer(_a) {
    var media = _a.media, _b = _a.mode, mode = _b === void 0 ? "top" : _b, _c = _a.enableWheelZoom, enableWheelZoom = _c === void 0 ? false : _c, className = _a.className, style = _a.style, sx = _a.sx, topLeftHoverComponents = _a.topLeftHoverComponents, topRightHoverComponents = _a.topRightHoverComponents, topRightZoomIn = _a.topRightZoomIn, topRightZoomOut = _a.topRightZoomOut, _d = _a.testId, testId = _d === void 0 ? "PictureViewer" : _d;
    return (React__default.createElement(Box, { className: clsx(CSS_MAIN_CLASS, className), "data-testid": testId, style: style, sx: __assign({ width: "100%", height: "100%" }, sx) },
        React__default.createElement(TransformWrapper, { wheel: {
                disabled: !enableWheelZoom
            }, disabled: !enableWheelZoom && !topRightZoomIn && !topRightZoomOut, panning: {
                // we deactivate velocity in order to avoid glitches (the image moves by a few pixels when we zoom and when we pan)
                velocityDisabled: true
            } }, function (_a) {
            var _b;
            var zoomIn = _a.zoomIn, zoomOut = _a.zoomOut;
            return (React__default.createElement(Box, { sx: (_b = {
                        position: "relative",
                        height: "100%",
                        width: "100%"
                    },
                    _b["&:hover .".concat(CSS_ACTIONS_CLASS, " button")] = {
                        opacity: "0.4"
                    },
                    _b) },
                React__default.createElement(Box, { className: CSS_ACTIONS_CLASS, sx: __assign(__assign({}, sxAction), { left: "10px" }) }, topLeftHoverComponents === null || topLeftHoverComponents === void 0 ? void 0 : topLeftHoverComponents.map(function (component) { return component; })),
                React__default.createElement(Box, { className: CSS_ACTIONS_CLASS, sx: __assign(__assign({}, sxAction), { right: "10px" }) }, topRightHoverComponents === null || topRightHoverComponents === void 0 ? void 0 :
                    topRightHoverComponents.map(function (component) { return component; }),
                    topRightZoomIn && React__default.createElement(ZoomAction, { onAction: zoomIn }, topRightZoomIn),
                    topRightZoomOut && React__default.createElement(ZoomAction, { onAction: zoomOut }, topRightZoomOut)),
                React__default.createElement(TransformComponent, { contentStyle: {
                        height: "100%",
                        width: "100%",
                        justifyContent: "center",
                        alignContent: mode === "center" ? "center" : "flex-start"
                    }, wrapperStyle: {
                        height: "100%",
                        width: "100%"
                    } },
                    React__default.createElement("img", { key: media === null || media === void 0 ? void 0 : media.id, src: media.previewUrl, alt: "", loading: "lazy", style: __assign(__assign({ objectFit: "scale-down" }, (mode === "center" && {
                            width: "100%",
                            height: "100%"
                        })), (mode === "top" && {
                            maxWidth: "100%",
                            maxHeight: "100%"
                        })) }))));
        })));
};
var sxAction = {
    position: "absolute",
    zIndex: 1,
    top: "10px",
    display: "flex",
    gap: "5px"
};
var ZoomAction = function ZoomAction(_a) {
    var children = _a.children, onAction = _a.onAction;
    if (React__default.isValidElement(children)) {
        return React__default.cloneElement(children, {
            onClick: function () { return onAction(); }
        });
    }
    return React__default.createElement(React__default.Fragment, null);
};

export { PictureViewer as default };
//# sourceMappingURL=index.js.map
